// -----------------------------------------------------------------------------
// ConfirmDeleteModal — Confirmation de suppression (soft delete)
// StockPro / VisualisPro
// -----------------------------------------------------------------------------

import { T } from "../i18n/translations";
import { getColors } from "../styles/theme";
import { Ic, ICONS } from "./Icons";

export default function ConfirmDeleteModal({
  product,
  lang,
  dark,
  onConfirm,
  onClose,
}) {
  const t = T[lang];
  const { textPrimary, textSecondary } = getColors(dark);

  return (
    <div
      className="modal-bg"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div style={{ background:dark?"#0f0f1a":"#fff", border:"1px solid rgba(239,68,68,.2)", borderRadius:18, padding:"22px", width:"100%", maxWidth:340, textAlign:"center" }}>
        <div style={{ width:46, height:46, background:"rgba(239,68,68,.1)", borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 12px" }}>
          <Ic d={ICONS.trash} size={22} color="#ef4444" />
        </div>
        <div style={{ fontWeight:700, color:textPrimary, fontSize:15, marginBottom:6 }}>{t.confirmDelete}</div>
        <div style={{ color:textSecondary, fontSize:12, marginBottom:18 }}>{t.irreversible}</div>
        <div style={{ display:"flex", gap:8 }}>
          <button
            onClick={onClose}
            style={{ flex:1, padding:"10px", background:dark?"rgba(255,255,255,.06)":"rgba(0,0,0,.06)", borderRadius:9, color:textSecondary, fontWeight:600, border:"none", cursor:"pointer" }}
          >
            {t.cancel}
          </button>
          <button
            onClick={() => onConfirm(product)}
            style={{ flex:1, padding:"10px", background:"rgba(239,68,68,.12)", borderRadius:9, color:"#f87171", fontWeight:600, border:"1px solid rgba(239,68,68,.2)", cursor:"pointer" }}
          >
            {t.delete}
          </button>
        </div>
      </div>
    </div>
  );
}
